import { cn } from '@/service/utils/cn';

type TAvailabilityInfoProps = {
    className?: string;
    ticketsAvail: number;
    showTitle?: boolean;
};

export const AvailabilityInfo = ({
    className,
    ticketsAvail,
    showTitle = false,
}: TAvailabilityInfoProps) =>
    ticketsAvail > 0 && (
        <div
            title={showTitle ? `${ticketsAvail} Left` : ''}
            className={cn(
                `min-h-9 mt-0.5 flex w-[117px] flex-shrink-0 items-center gap-x-2 rounded-2xl px-3 py-[5px]`,
                ticketsAvail < 10
                    ? 'bg-red-4 text-red-7 dark:bg-red-6'
                    : 'bg-ash-dark text-gray-1 dark:dark:bg-dark-2 dark:text-gray-3',
                className
            )}
            data-test-id="calendar-avail-info"
        >
            <span className="tx-large-to-small-medium text-left font-medium">
                {ticketsAvail < 10 ? `${ticketsAvail} Left` : ticketsAvail}
            </span>
        </div>
    );
